import { useId, type ReactNode } from 'react'

import { IconQuestion } from '../../styles/images/icons'
import { Button } from '../ui/button'
import { Flex } from '../ui/flex'
import { Modal } from '../ui/modal'
import { SafeMessage } from '../ui/safe-message'
import css from './modal.confirm.module.scss'


/** Свойства окна подтверждения действия */
export interface IModalConfirm {
    isOpen: boolean
    isLoading?: boolean
    maxWidth?: string
    containerClassName?: string
    
    headerText?: string
    content?: ReactNode
    contentText?: string
    cancelButtonText?: string
    okButtonText?: string

    handleButtonOk?: () => void | Promise<void>
    handleButtonCancel?: () => void
}


/** Окно подтверждения действия */
export const ModalConfirm = ({isOpen, isLoading, maxWidth, containerClassName, headerText, content, contentText, cancelButtonText, okButtonText, handleButtonCancel, handleButtonOk}: IModalConfirm) => {
    const titleId = useId()
    const modalContainerClassName = ['modal_container', css.container, containerClassName].filter(Boolean).join(' ')

    return <Modal className={css.dialog} isOpen={isOpen} isEsc={!isLoading} isWrapper maxWidth={maxWidth || '480px'} ariaLabelledBy={titleId} onCancel={isLoading ? undefined : handleButtonCancel} onOk={isLoading ? undefined : handleButtonOk}>
        <Flex className={modalContainerClassName}>
            <Flex className={`modal_container-header ${css.header}`} flexDirection='row' alignItems='center'>
                <span className={css.icon} aria-hidden='true'>
                    <IconQuestion width='22px' height='22px' />
                </span>
                <div className={css.heading}>
                    <span>Требуется подтверждение</span>
                    <h4 id={titleId}>{headerText || 'Подтверждение действия'}</h4>
                </div>
            </Flex>

            <div className={`modal_confirm-body ${css.body}`}>
                <Flex className={`modal_container-content ${css.content}`}>
                    {content || (
                        <div className={css.message}>
                            <SafeMessage message={contentText} fallback='Привет:<br/>Вы не указали текст!' />
                        </div>
                    )}
                </Flex>

                <div className={`modal_confirm-actions ${css.actions}`}>
                    <Button variant='primaryDark' width='100%' isDisabled={isLoading} onClick={handleButtonCancel}>{cancelButtonText || 'Отмена'}</Button>
                    <Button width='100%' isDisabled={isLoading} isLoading={isLoading} onClick={handleButtonOk}>{okButtonText || 'Подтвердить'}</Button>
                </div>
            </div>
        </Flex>
    </Modal>
}